import { IRootState } from '../../../store'
import { IZipState } from '../store/zip.types'

export const getZipSelector = (state: IRootState): IZipState => state.zip
